import { Button, Stack } from "react-bootstrap";
import { useShoppingCart } from "../context/ShoppingCartContext";
import { formatCurrency } from "../utilities/formatCurrency";
import { Dash, Plus } from "react-bootstrap-icons";
import OrderSkeleton from "./skeletons/OrderSkeleton";
import { useProduct, useProductOptionItems } from "../lib/query/queries/useProductQueries";

export function OrderItem({
  id,
  quantity,
  selectedOptions,
  showPrice,
  checked,
}) {
  // Same cache entries as CartItem.jsx — a product/option already fetched
  // for the cart is reused here instead of re-fetched.
  const { data: product = {}, isLoading: isProductLoading } = useProduct(id);
  const { data: sops, isLoading: isOptionsLoading } = useProductOptionItems(id, selectedOptions);
  const isLoading = isProductLoading || isOptionsLoading;

  var sopsTxt = "";

  if (sops.length > 0) {
    for (var s = 0; s < sops.length; s++) {
      const sop = sops[s];
      sopsTxt = sop.value + ". " + sopsTxt;
    }
  }

  return (
    <>
      {isLoading ? (
        <OrderSkeleton />
      ) : (
        <Stack
          direction="horizontal"
          gap={2}
          className="d-flex align-items-center p-2 font-monospace"
        >
          <img
            src={product.imageSrc}
            style={{ width: "105px", height: "75px", objectFit: "contain" }}
          />
          <div className="me-auto">
            <div style={{ fontSize: "1.125rem" }} className="text-dark">
              {product.name}{" "}
              {quantity > 1 && (
                <span className="text-primary" style={{ fontSize: ".65rem" }}>
                  x{quantity}
                </span>
              )}
            </div>
            <div className="text-secondary" style={{ fontSize: ".78rem" }}>
              {sopsTxt}
            </div>
            {product != "" ? (
              <div className="text-secondary" style={{ fontSize: ".78rem" }}>
                <p>
                  {product.type} {"/"} {product.subType}
                </p>
              </div>
            ) : null}
            {showPrice && (
              <div className="text-dark fw-medium" style={{ fontSize: ".86rem" }}>
                {formatCurrency(product.price)}
              </div>
            )}
          </div>
        </Stack>
      )}
    </>
  );
}
